import { createApiSaga } from '../../../sagaGenerator';
import { apiGet } from '../../../../middleware/api';
import {
  MARIGRAM_SEARCH_REQUEST,
  MARIGRAM_SEARCH_SUCCESS,
  MARIGRAM_SEARCH_FAILURE,
  MARIGRAM_SEARCH_REGION_REQUEST,
  MARIGRAM_SEARCH_REGION_SUCCESS,
  MARIGRAM_SEARCH_REGION_FAILURE,
  MARIGRAM_SEARCH_COUNTRY_FAILURE,
  MARIGRAM_SEARCH_COUNTRY_REQUEST,
  MARIGRAM_SEARCH_COUNTRY_SUCCESS,
  MARIGRAM_SEARCH_LOCATION_FAILURE,
  MARIGRAM_SEARCH_LOCATION_REQUEST,
  MARIGRAM_SEARCH_LOCATION_SUCCESS,
  MARIGRAM_SEARCH_STATE_FAILURE,
  MARIGRAM_SEARCH_STATE_REQUEST,
  MARIGRAM_SEARCH_STATE_SUCCESS,
} from './marigramSearchReducer';


const searchMarigramsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/marigrams', ...action }),
  requestType: MARIGRAM_SEARCH_REQUEST,
  successType: MARIGRAM_SEARCH_SUCCESS,
  failureType: MARIGRAM_SEARCH_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/regions', ...action }),
  requestType: MARIGRAM_SEARCH_REGION_REQUEST,
  successType: MARIGRAM_SEARCH_REGION_SUCCESS,
  failureType: MARIGRAM_SEARCH_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/countries', ...action }),
  requestType: MARIGRAM_SEARCH_COUNTRY_REQUEST,
  successType: MARIGRAM_SEARCH_COUNTRY_SUCCESS,
  failureType: MARIGRAM_SEARCH_COUNTRY_FAILURE,
});

const getLocationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/locations', ...action }),
  requestType: MARIGRAM_SEARCH_LOCATION_REQUEST,
  successType: MARIGRAM_SEARCH_LOCATION_SUCCESS,
  failureType: MARIGRAM_SEARCH_LOCATION_FAILURE,
});

const getStatesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunamis/marigrams/states/${action.country}`, ...action }),
  requestType: MARIGRAM_SEARCH_STATE_REQUEST,
  successType: MARIGRAM_SEARCH_STATE_SUCCESS,
  failureType: MARIGRAM_SEARCH_STATE_FAILURE,
});


export const searchMarigramsSagas = [
  searchMarigramsSaga,
  getLocationsSaga,
  getRegionsSaga,
  getCountriesSaga,
  getStatesSaga,
];
